import PropTypes from 'prop-types'
import { MainPanel } from '@calendly/booking-kit'
import { TitleText } from '@calendly/ui/components/typography'

import Wrapper from 'components/wrapper'
import Container from 'components/layout/container'
import { useI18n } from 'locales'

import { Panel, Description } from './styles'

const MeetingPackageCanceled = ({ hostName }) => {
  const { i18n } = useI18n()

  return (
    <Wrapper>
      <Container>
        <MainPanel>
          <Panel>
            <TitleText level={1} size="large" as="h1">
              {i18n.t('booking.package.cancellation.heading')}
            </TitleText>
            <Description>
              {i18n.t('booking.package.cancellation.description', {
                host_name: hostName
              })}
            </Description>
          </Panel>
        </MainPanel>
      </Container>
    </Wrapper>
  )
}

MeetingPackageCanceled.propTypes = {
  hostName: PropTypes.string
}

export default MeetingPackageCanceled
